import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useQuery } from '@apollo/react-hooks'
import { pathEq } from 'ramda'

import { useIsAuthenticated } from '../../../../hooks/use-is-authenticated'
import { useWelcomeBack } from './hooks/use-welcome-back'
import ACCOUNT_QUERY_WITH_DIR from '../../../../../graphql/queries/account-with-directives.gql'
import ActionTypes from '../../../../actions/types'
import Button from '../../../button'
import { useStyles } from './welcome-back-banner.styles'
/**
 * Renders the welcome back banner
 */
const WelcomeBackBanner = () => {
  const styles = useStyles()
  const location = useLocation()
  const dispatch = useDispatch()
  const isAuthenticated = useIsAuthenticated()

  const {
    headerAndCopy,
    confirmText,
    handleConfirm
  } = useWelcomeBack()

  const [userHasDismissedBanner, setUserHasDismissedBanner] = useState(false)

  const { data, loading, error } = useQuery(ACCOUNT_QUERY_WITH_DIR, {
    fetchPolicy: 'cache-first',
    skip: !isAuthenticated,
    variables: {
      withCreditcards: true,
      withSubscription: true
    }
  })

  if (loading || error) return null

  const userHasSubscription = pathEq(
    ['account', 'subscription', 'status'],
    'ACTIVE'
  )(data || {})

  const isInSignUpFlow = /^\/sign-up(\/|$)/.test(location.pathname)

  const shouldRenderBanner = isAuthenticated &&
    !isInSignUpFlow &&
    !userHasSubscription &&
    !userHasDismissedBanner

  const handleDismiss = () => {
    setUserHasDismissedBanner(true)
    dispatch({ type: ActionTypes.SET_SHOW_WELCOME_BACK_BANNER, payload: false })
  }

  const handleConfirmClick = () => {
    dispatch({ type: ActionTypes.SET_SHOW_WELCOME_BACK_BANNER, payload: false })
    handleConfirm()
  }

  const renderHeaderAndCopy = () => {
    return (
      headerAndCopy.map((dialog, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className={styles.messageGroup}>
          <div className={styles.header}>
            {dialog.header}
          </div>
          <div className={styles.copy}>
            {dialog.msg}
          </div>
        </div>
      ))
    )
  }

  if (!shouldRenderBanner) return null

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>{renderHeaderAndCopy()}</div>

        <div className={styles.buttons}>
          <Button
            className={styles.button}
            text="No thanks"
            darkBGSecondary
            onClick={handleDismiss}
          />

          <Button
            className={styles.button}
            text={confirmText}
            onClick={handleConfirmClick}
          />
        </div>
      </div>
    </div>
  )
}

export default WelcomeBackBanner
